// extracted by mini-css-extract-plugin
export default {"divBg":"HomePage_divBg__qA-47","title":"HomePage_title__DWlEo","img":"HomePage_img__NLnch","imgLogo":"HomePage_imgLogo__eD5Mt"};